import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft, ShieldCheck } from "lucide-react";

export default function Login() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const handleGoogleLogin = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-cream flex flex-col">
      <div className="max-w-7xl w-full mx-auto px-5 sm:px-8 py-6">
        <a href="/" className="text-sm text-ink/70 hover:text-clay inline-flex items-center gap-1.5" data-testid="back-to-site">
          <ArrowLeft className="w-4 h-4" /> Back to site
        </a>
      </div>

      <div className="flex-1 grid lg:grid-cols-2 max-w-7xl w-full mx-auto px-5 sm:px-8 pb-16 gap-12 items-center">
        <div>
          <p className="eyebrow">Admin portal</p>
          <h1 className="text-4xl sm:text-5xl font-display text-forest mt-3 leading-tight">
            Your patient acquisition command room.
          </h1>
          <p className="text-ink/70 mt-4 max-w-lg leading-relaxed">
            Track leads, manage callback queues, review chatbot conversations and measure which Instagram, Facebook or TikTok
            campaign is bringing in patients — all in one place.
          </p>

          <ul className="mt-8 space-y-3 text-sm text-ink/80">
            <li className="flex gap-2"><ShieldCheck className="w-5 h-5 text-clay"/> Secure Google sign-in — no passwords to manage</li>
            <li className="flex gap-2"><ShieldCheck className="w-5 h-5 text-clay"/> Session expires in 7 days automatically</li>
            <li className="flex gap-2"><ShieldCheck className="w-5 h-5 text-clay"/> Only authorised staff can view patient data</li>
          </ul>
        </div>

        <div className="bg-white border border-border rounded-2xl p-8 sm:p-10">
          <p className="eyebrow">Sign in</p>
          <h2 className="text-2xl sm:text-3xl font-display text-forest mt-2">Welcome back.</h2>
          <p className="text-ink/70 text-sm mt-2">Continue with your practice Google account to access the dashboard.</p>

          <Button
            onClick={handleGoogleLogin}
            className="mt-8 w-full h-12 bg-forest hover:bg-forest-dark text-cream rounded-lg"
            data-testid="google-login-button"
          >
            <svg viewBox="0 0 24 24" className="w-5 h-5 mr-2" xmlns="http://www.w3.org/2000/svg">
              <path fill="#fff" d="M21.35 11.1H12v3.2h5.35c-.23 1.23-.93 2.27-1.98 2.97v2.47h3.2c1.87-1.72 2.95-4.26 2.95-7.24 0-.7-.06-1.37-.17-2z"/>
              <path fill="#fff" d="M12 22c2.67 0 4.9-.88 6.53-2.37l-3.2-2.47c-.89.6-2.03.96-3.33.96-2.56 0-4.73-1.73-5.5-4.06H3.2v2.55A10 10 0 0012 22z" opacity=".7"/>
              <path fill="#fff" d="M6.5 14.06a6.03 6.03 0 010-4.12V7.39H3.2a10 10 0 000 9.22l3.3-2.55z" opacity=".5"/>
              <path fill="#fff" d="M12 5.93c1.45 0 2.76.5 3.78 1.48l2.84-2.84A10 10 0 003.2 7.4l3.3 2.55C7.27 7.66 9.44 5.93 12 5.93z" opacity=".8"/>
            </svg>
            Continue with Google
          </Button>

          <p className="text-[11px] text-ink/60 mt-6 text-center">
            By continuing, you agree to our acceptable use policy.
          </p>
        </div>
      </div>
    </div>
  );
}
